<div class="listTile noSelect">
  @if (!!leadingIcon) {
    <mat-icon [class.disabled]="disabled">{{
      leadingIcon
    }}</mat-icon>
  }
  <div class="column">
    <div class="listTileTitle">
      <h4 [class.disabled]="disabled">{{ title }}</h4>
      @if (!!trailingIcon) {
        <mat-icon [class.disabled]="disabled">{{
          trailingIcon
        }}</mat-icon>
      }
    </div>
    @if (!!subtitle) {
      <p>{{ subtitle }}</p>
    }
  </div>
</div>
